import {
  ActivityNotificationsAction,
  LOAD_ACTIVITY_NOTIFICATIONS,
  LOAD_ACTIVITY_NOTIFICATIONS_FAIL,
  LOAD_ACTIVITY_NOTIFICATIONS_SUCCESS,
  LoadActivityNotificationsSuccess
} from '../actions/activity-notifications.action';
import {IActivityNotification} from '../../activity-notifications/activity-notification';
import {
  ADD_ACTIVITY_NOTIFICATION,
  AddActivityNotification,
  INIT_ACTIVITY_NOTIFICATIONS_SOCKET,
  MARK_READ_ACTIVITY_NOTIFICATIONS,
  TOGGLE_ACTIVITY_NOTIFICATIONS,
  ToggleActivityNotifications
} from "../actions";
import {TypeUtils} from "../../shared/utils/type-utils";

export interface IWebsiteActivityNotificationsState {
  websiteId: number;
  entities: {[activityNotificationId: string]: IActivityNotification};
}

export interface IActivityNotificationsState {
  entities: {[websiteId: number]: IWebsiteActivityNotificationsState};
  loading: boolean;
  loaded: boolean;
  toggled: boolean;
}

export const initialState: IActivityNotificationsState = {
  entities: {},
  loading: false,
  loaded: false,
  toggled: false
};

export function reducer(state: IActivityNotificationsState = initialState, action: ActivityNotificationsAction): IActivityNotificationsState {
  let payload: any;

  switch (action.type) {

    case LOAD_ACTIVITY_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_ACTIVITY_NOTIFICATIONS_SUCCESS:
      payload = (<LoadActivityNotificationsSuccess>action).payload;

      return {
        ...state,
        entities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_ACTIVITY_NOTIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case INIT_ACTIVITY_NOTIFICATIONS_SOCKET:
      return state;

    case ADD_ACTIVITY_NOTIFICATION:
      const addedActivityNotification: IActivityNotification = (<AddActivityNotification>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [addedActivityNotification.websiteId]: {
            ...state.entities[addedActivityNotification.websiteId],
            entities: {
              ...(state.entities[addedActivityNotification.websiteId] ? state.entities[addedActivityNotification.websiteId].entities : {}),
              [addedActivityNotification.id]: addedActivityNotification
            }
          }
        }
      };

    case MARK_READ_ACTIVITY_NOTIFICATIONS:
      Object.values(state.entities).forEach((websiteActivityNotificationsState: IWebsiteActivityNotificationsState): void => {
        websiteActivityNotificationsState.entities = Object.values(websiteActivityNotificationsState.entities).reduce((entities, activityNotification: IActivityNotification) => {
          entities[activityNotification.id] = {
            ...activityNotification,
            isNew: false
          };

          return entities;
        }, {});
      });

      return state;

    case TOGGLE_ACTIVITY_NOTIFICATIONS:
      let toggled: boolean = (<ToggleActivityNotifications>action).payload;
      if (TypeUtils.isUndefined(toggled)) {
        toggled = !state.toggled;
      }

      return {
        ...state,
        toggled: toggled
      };

  }

  return state;
}
